/*@ngInject*/
module.exports = function authService($http, $location, $q, $window, $timeout, $rootScope) {
    'use strict';
    const _this = this;

    const tokenStorageKey = 'lips_jwt_token';

    this.saveToken = function(token) {
        $window.localStorage.clear();
        $window.localStorage[tokenStorageKey] = token;
    };

    this.getToken = function() {
        return $window.localStorage[tokenStorageKey];
    };

    this.isAuthenticated = function() {
        const token = this.getToken();
        return !!token;
    };

    this.removeToken = function() {
        $window.localStorage.removeItem(tokenStorageKey);
    };

    this.login = function(username, password) {
        return $http({
            url: 'auth/login',
            method: 'POST',
            data: {username: username, password: password}
        }).then(function (resp) {
            _this.saveToken(resp.data);
            _this.getCurrentUser().then(function() {
                $timeout(function () {
                    $location.path('');
                }, 500);
            });
        });
    };

    this.saveTokenAndRedirect = function(token) {
        this.saveToken(token);
        this.getCurrentUser().then(function(currentUser) {
            $rootScope.currentUser = currentUser.data;
            $location.path('');
        });
    };

    this.getTaraLoginUrl = function () {
        return $http.get('auth/getTaraLoginUrl');
    };

    this.getTaraUserFromSession = function () {
        return $http.get('auth/getTaraUserFromSession');
    };

    this.logout = function() {
        this.removeToken();
        $rootScope.currentUser = null;
        $location.path('login');
    };

    this.getCurrentUser = function() {
        if (!this.isAuthenticated()) {
            return $q.when(null);
        }
        return $http.get('auth/getCurrentUser');
    };

    this.getUser = function(id) {
        return $http.get('users/getUser/?id='+id);
    };

    this.search = function(){
        return $http.get('users/search/', {
            ignoreLoadingBar: true
        });
    };

    this.getAll = function(){
        return $http.get('users/getAll/');
    };

    this.save = function(user) {
        return $http.post('users/save', user);
    };

    this.checkUserName = function(username, user_id){
        return $http.post('users/checkUserName', {username:username,user_id:user_id}, {
            ignoreLoadingBar: true
        });
    };

    this.checkUserCode = function(code, user_id){
        return $http.post('users/checkUserCode', {code:code,user_id:user_id}, {
            ignoreLoadingBar: true
        });
    };

    this.checkValidCode = function(code){
        return $http.post('users/checkValidCode', {code:code}, {
            ignoreLoadingBar: true
        });
    };

};


/** WEBPACK FOOTER **
 ** ./app/shared/auth/auth.service.js
 **/